"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      height: 40,
      backgroundColor: palette.yellow.sunflower,
      alignItems: 'center',
      justifyContent: 'center'
    },
    icon: {
      marginRight: spacing(2)
    }
  };
});

var EmailPreviewWarningBar = function EmailPreviewWarningBar() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Center-Chambray-Bold"
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "eye",
    className: classes.icon
  }), "This is only a preview of your email"));
};

var _default = EmailPreviewWarningBar;
exports.default = _default;